import axios from '@/plugins/axios'
import router from '@/plugins/router'
import { Message } from "element-ui";

export default {
  namespaced: true,

  state: {
    user: null,
    artist: null,
    loading: false,
    is_toggled: false,
    maintenance: false,
    resetPasswordErrors: {},
    forgotPasswordErrors: {}
  },

  mutations: {
    setUser(state, payload) {
      state.user = payload
    },
    setArtist(state, payload) {
      state.artist = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setToggle(state, payload) {
      state.is_toggled = payload
    },
    setMaintenance(state, payload) {
      state.maintenance = payload
    },
    setResetPasswordErrors(state, errors) {
      state.resetPasswordErrors = errors
    },
    setForgotPasswordErrors(state, errors) {
      state.forgotPasswordErrors = errors
    }
  },

  actions: {
    login({ commit }, payload) {
      commit('setArtist', null)
      commit('setLoading', true)
      axios.admin
        .post('login', {
          username: payload.username,
          password: payload.password
        })
        .then(r => {
          // dispatch('readUser')
          localStorage.setItem('token', r.data.data.access_token)
          localStorage.setItem('role', r.data.data.role)
          commit('setLoading', false)
          if (r.data.data.role == 'artist_admin') {
            router.push('/artist/home')
          } else if (r.data.data.role == 'label_admin') {
            router.push('/label/home')
          } else if (r.data.data.role == 'content_admin') {
            router.push('/content/home')
          } else {
            router.push('/')
          }
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    passwordReset({ commit }, payload) {
      commit('setLoading', true)
      axios.apiBasic
        .post('user/password-reset', {
          email: payload.email,site: payload.site
        })
        .then(() => {
          Message({
            message: 'Password reset link successfully sent', type: 'success'
          })
          commit('setLoading', false)
        })
        .catch(({ response }) => {
          commit('setLoading', false)
          commit('setForgotPasswordErrors', response.data.errors)
        })
        .finally(() => setTimeout(() => commit('setForgotPasswordErrors', {}), 5000))
    },

    newPassword({ commit }, payload) {
      commit('setLoading', true)
      axios.apiBasic
        .post('user/reset-password', {
          password: payload.password, confirm_password:payload.password_check, token: payload.token
        })
        .then(() => {
          Message({
            message: 'You have successfully reset your password', type: 'success'
          })
          router.push({ name: 'Login' })
          commit('setLoading', false)
        })
        .catch(({ response }) => {
          if ('token' in response.data.errors) {
            Message({type: 'error', message: response.data.errors.token[0]})
          }
          commit('setLoading', false)
          commit('setResetPasswordErrors', response.data.errors)
        })
        .finally(() => setTimeout(() => commit('setResetPasswordErrors', {}), 5000))
    },
    async readUser({ commit }) {
      if (localStorage.getItem('role') == 'label_admin') {
        await axios.label
          .get('user/me')
          .then(r => {
            commit('setUser', r.data.data[0])
            commit('setMaintenance', false)
          })
          .catch(e => {
            commit('setUser', null)
            if(e.response.status == 503){
              commit('setMaintenance', true)
            }
          })
      } else if (localStorage.getItem('role') == 'artist_admin') {
        await axios.artist
          .get('user/me')
          .then(r => {
            commit('setUser', r.data.data[0])
            commit('setMaintenance', false)
          })
          .catch(e => {
            commit('setUser', null)
            if(e.response.status == 503){
              commit('setMaintenance', true)
            }
          })
      } else if (localStorage.getItem('role') == 'sysadmin') {
        await axios.admin
          .get('user/me')
          .then(r => {
            commit('setUser', r.data.data[0])
            commit('setMaintenance', false)
          })
          .catch(e => {
            commit('setUser', null)
            if(e.response.status == 503){
              commit('setMaintenance', true)
            }
          })
      } else if (localStorage.getItem('role') == 'content_admin') {
        await axios.content
          .get('user/me')
          .then(r => {
            commit('setUser', r.data.data[0])
            commit('setMaintenance', false)
          })
          .catch(e => {
            commit('setUser', null)
            if(e.response.status == 503){
              commit('setMaintenance', true)
            }
          })
      }
    },

    readArtist({ commit }) {
      axios.artist.get('settings').then(r => {
        commit('setArtist', r.data.data[0])
      })
    },

    deleteImage() {
      if (localStorage.getItem('role') == 'label_admin') {
        axios.label
          .delete('user/image/delete')
          .then(r => {})
          .catch(() => {})
      } else if (localStorage.getItem('role') == 'artist_admin') {
        axios.artist
          .delete('user/image/delete')
          .then(r => {})
          .catch(() => {})
      }
    }
  },

  getters: {
    admin_role: state => {
      return state.user.user_level === 'sysadmin'
    },

    artist_role: state => {
      return state.user.user_level === 'artist_admin'
    },

    label_role: state => {
      return state.user.user_level === 'label_admin'
    },

    content_role: state => {
      return state.user.user_level === 'content_admin'
    },

    mcn_role: state => {
      return state.user.user_level === 'company_admin'
    },

    toggle: state => state.is_toggled
  }
}
